<template>
  <tr>
    <td>{{ item.min | currency }}</td>
    <td>{{ item.max | currency }}</td>
    <td>{{ item.flat_commission | currency }}</td>
    <td>{{ item.percentage_comission | currency }} %</td>
    <td>{{ item.flat_fees | currency }}</td>
    <td>{{ item.percentage_fees }} %</td>
    <td>
      <v-btn icon title="Delete entry" @click="handleDelete(item)">
        <v-icon>mdi-delete-outline</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>mdi-circle-edit-outline</v-icon>
      </v-btn>
    </td>
  </tr>
</template>
<script>
export default {
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  methods: {
    handleDelete(item) {
      window.Notify.confirm("This will delete the entry permanently from the database").then(() => {
        this.$http
          .delete(`api/v1/transactions/earningStructure/${item.id}`)
          .then(() => this.$emit("deleted", item))
          .catch((response) => window.Notify.errorFromResponse(response));
      });
    },
  },
};
</script>
<style scoped lang="scss">
td {
  border: 0.5px solid rgba(0, 0, 0, 0.12);
  border-collapse: collapse;
}
</style>
